import {
    Home,
    Cinemas,
    FAQ,
    Details,
    User,
    PasswordReset,
    Profile,
    Payment,
    PaymentDonation,
    Booking,
    Seats,
    Promo,
    ClubLoyalty,
    ClubLoyaltyInfo,
    Content,
    Preview,
    ExclusiveToSK,
    FilmFestivalDetails,
    Event,
    Competitions,
	Competition,
    PageNotFound,
    VisionMissionDonate,
    PasswordValidate,
    ConfirmEmailChange,
    Activate,
    SubsClub,
    GenrePage,
    CinemasPage
} from '@/components/pages';
import {Seating, Extras, CheckTicket, Checkout,BookingSuccessful,BookingUnsuccessful} from '@/components/booking'
import {Events, SeeAll, Promotions, FilmFestivals} from '@/components/exclusive-to-sk'


export default [
    { path: "*", component: PageNotFound, redirectParams: {responseCode: 404}},
    {
        path: '/',
        name: 'Home',
        topNav: true,
        component: Home,
        children: [
            {
                path: '/cinema/:cinema_name',
                name: 'Home-cinema',
                topNav: false,
                component: Home
            },
            {
                path: '/cinema/:cinema_name/type/:cinema_type',
                name: 'Home-cinema-type',
                topNav: false,
                component: Home
            },
            {
                path: '/cinema/:cinema_name/type/:cinema_type/genres/:genres',
                name: 'Home-cinema-type-genre',
                topNav: false,
                component: Home
            },
            {
                path: '/cinema/:cinema_name/type/:cinema_type/genres/:genres/time/:time_range',
                name: 'Home-cinema-type-genre-time',
                topNav: false,
                component: Home
            },
            {
                path: '/type/:cinema_type',
                name: 'Home-type',
                topNav: false,
                component: Home
            },
            {
                path: '/type/:cinema_type/genres/:genres',
                name: 'Home-type-genre',
                topNav: false,
                component: Home
            },
            {
                path: '/type/:cinema_type/genres/:genres/time/:time_range',
                name: 'Home-type-genre-time',
                topNav: false,
                component: Home
            },
            {
                path: '/genres/:genres',
                name: 'Home-genre',
                topNav: false,
                component: Home
            },
            {
                path: '/genres/:genres/time/:time_range',
                name: 'Home-genre-time',
                topNav: false,
                component: Home
            },
            {
                path: '/time/:time_range',
                name: 'Home-time',
                topNav: false,
                component: Home,
                hash: "#filter"
            },
            {
                path: '/type/:cinema_type/time/:time_range',
                name: 'Home-type-time',
                topNav: false,
                component: Home
            },
            {
                path: '/cinema/:cinema_name/time/:time_range',
                name: 'Home-cinema-time',
                topNav: false,
                component: Home
            },
            {
                path: '/cinema/:cinema_name/genres/:genres/time/:time_range',
                name: 'Home-cinema-genre-time',
                topNav: false,
                component: Home
            },
            {
                path: '/cinema/:cinema_name/genres/:genres',
                name: 'Home-cinema-genre',
                topNav: false,
                component: Home
            },
            {
                path: '/cinema/:cinema_name/type/:cinema_type/time/:time_range',
                name: 'Home-cinema-type-time',
                topNav: false,
                component: Home
            },
        ]
    },    
    
    {
        path: '/competitions',
        name: 'Competitions',
        topNav: true,
        component: Competitions
    },
    {
        path: '/club-loyalty',
        name: 'SK Club & Movie Cards',
        topNav: true,
        component: ClubLoyalty
    },
    {
        path: '/subscription-club',
        name: 'SK Subscription Club',
        topNav: true,
        component: SubsClub
    },
    {
        path: '/club-loyalty/:card_name',
        name: 'SK Club & loyalty Info',
        topNav: false,
        component: ClubLoyaltyInfo
    },
  
    {
        path: '/exclusive-to-sk',
        name: 'Exclusive to SK',
        topNav: true,
        component: ExclusiveToSK,
        redirect: 'exclusive-to-sk/promotions',
        children: [
            {
                path: 'promotions',
                name:'Promotions',
                component: Promotions
            },
            {
                path: 'events',
                name:'Events',
                component: Events
            },
            {
                path: 'film-festivals',
                name:'Film Festivals & Live',
                component: FilmFestivals
            },

        ]
    },
    {
        path: '/type/Nouveau',
        name: 'Cinema Nouveau',
        topNav: true,
        component: Home
    },
    {
        path: '/film-festival-details/:id',
        name: 'Film Festival Details',
        component: FilmFestivalDetails
    },
    {
        path: '/film-festival-details/:id',
        name: 'Film Festival Details',
        component: FilmFestivalDetails
    },
    {
        path: '/details/:id',
        name: 'details',
        topNav: false,
        component: Details,
        children: [
            {
                path: '/details/:id',
                name: 'details',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/session/:session_id',
                name: 'details',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/cinema/:cinema_id',
                name: 'details_cinema',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/cinema/:cinema_id/types/:types/time/:time',
                name: 'details_cinema_types_time',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/cinema/:cinema_id/types/:types',
                name: 'details_cinema_types',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/cinema/:cinema_id/time/:time',
                name: 'details_cinema_time',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/types/:types/time/:time',
                name: 'details_types_time',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/types/:types',
                name: 'details_types',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/time/:time',
                name: 'details_time',
                topNav: false,
                component: Details
            },
        ]
    },
    {
        path: '/details/:id/:title',
        name: 'details_title',
        topNav: false,
        component: Details,
        children: [
            {
                path: '/details/:id/:title',
                name: 'details_title',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/session/:session_id/:title',
                name: 'details_title',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/cinema/:cinema_id/:title',
                name: 'details_cinema_title',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/cinema/:cinema_id/types/:types/time/:time/:title',
                name: 'details_cinema_types_time_title',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/cinema/:cinema_id/types/:types/:title',
                name: 'details_cinema_types_title',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/cinema/:cinema_id/time/:time/:title',
                name: 'details_cinema_time_title',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/types/:types/time/:time/:title',
                name: 'details_types_time_title',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/types/:types/:title',
                name: 'details_types_title',
                topNav: false,
                component: Details
            },
            {
                path: '/details/:id/time/:time/:title',
                name: 'details_time_title',
                topNav: false,
                component: Details
            },
        ]
    },
    {
        path: '/user/profile/manage-payment/:managepayment',
        name: 'profileManage',
        topNav: false,
        component: Profile
    },
    {
        path: '/user/profile',
        name: 'profile',
        topNav: false,
        component: Profile
    },
    {
        path: '/user/activate/:activationCode',
        name: 'useractivate',
        topNav: false,
        component: Activate
    },
    {
        path: '/user/:signInType',
        name: 'user',
        topNav: false,
        component: User
    },
    {
        path: '/user/password-validate/:resetCode',
        name: 'passwordvalidate',
        topNav: false,
        component: PasswordValidate
    },
    {
        path: '/user/request-card/:resetCode',
        name: 'requestcard',
        topNav: false,
        component: PasswordReset
    },
    {
        path: '/user/password-reset/:resetCode',
        name: 'passwordreset',
        topNav: false,
        component: PasswordReset
    },
    
    {
        path: '/details/:id/cinema/:cinema_id/session/:session_id',
        name: 'details_cinema',
        topNav: false,
        component: Details
    },
    {
        path: '/details/:id/film-festival/:festival_id',
        name: 'details_cinema',
        topNav: false,
        component: Details
    },
    {
        path: '/details/:id/film-festival/:festival_id/session/:session_id',
        name: 'details_cinema',
        topNav: false,
        component: Details
    },
    {
        path: '/booking',
        name: 'booking',
        topNav: false,
        component: Booking,

        children: [
            {
                path: '1',
                component: Seating
            },
            {
                path: '2',
                component: Extras
            },
            {
                path: '3',
                component: CheckTicket
            },
            {
                path: '4',
                component: Checkout
            }
        ]
    },
    {
        path: '/booking',
        name: 'booking',
        topNav: false,
        component: Booking,

        children: [
            {
                path: '1/film-festival/:festival_id',
                component: Seating
            },
            {
                path: '2/film-festival/:festival_id',
                component: Extras
            },
            {
                path: '3/film-festival/:festival_id',
                component: CheckTicket
            },
            {
                path: '4/film-festival/:festival_id',
                component: Checkout
            }
        ]
    },
    {
        path: '/booking-successful/:booking_number/:booking_id/:cinema_id',
        name: 'bookingSuccess',
        topNav: false,
        component: BookingSuccessful
    },
    {
        path: '/booking-unsuccessful',
        name: 'bookingFailure',
        topNav: false,
        component: BookingUnsuccessful
    },
    {
        path: '/seats/:cinema_id/:session_id',
        name: 'seats',
        topNav: false,
        component: Seats
    },
    {
        path: '/promotion/:id',
        name: 'Promo',
        topNav: false,
        component: Promo
    },
    {
        path: '/event/:id',
        name: 'Event',
        topNav: false,
        component: Event
    },
    {
        path: '/competition/:id',
        name: 'Competition',
        topNav: false,
        component: Competition
    },
    {
        path: '/payment/donation/:paymentType',
        name: '<PaymentDonation></PaymentDonation>',
        topNav: false,
        component: PaymentDonation
    },
    {
        path: '/payment/:paymentType',
        name: 'Payment',
        component: Payment
    },
    {
        path: '/user/confirm-email-change/:changeCode',
        name: 'ConfirmEmailChange',
        topNav: false,
        component: ConfirmEmailChange
    },
    {
        path: '/content/:content_url/:content_url_two?/:content_url_three?/:content_url_four?',
        name: 'content',
        topNav: false,
        component: Content
    },

    {
        path: '/preview/:content_type/id/:node_id',
        name: 'content',
        topNav: false,
        component: Preview
    },
    {
        path: '/genre/:genres',
        name: 'content',
        topNav: false,
        component: GenrePage
    }
]



// WEBPACK FOOTER //
// ./src/router/main-nav.js